import { defineAsyncComponent, markRaw } from 'vue'

import { MENU_TYPE } from '@/models/menu'

const COCKPIT_LINK_CONFIG = {
  actionName: 'action_bar_link_home',
  exact: true,
  iconClass: 'action-bar__menu',
  to: '/',
  tooltipText: 'Página inicial'
}

const WANDA_LINK_CONFIG = {
  actionName: 'action_bar_link_wanda',
  iconName: 'icCheckOutlined',
  id: 'action_bar_item_wanda',
  to: '/wanda',
  tooltipText: 'Wanda'
}

const BUD_LINK_CONFIG = {
  actionName: 'action_bar_link_bud',
  iconName: 'icProtocol',
  id: 'action_bar_item_bud',
  to: '/protocols/categories',
  tooltipText: 'BUD'
}

const HANDOFF_LINK_CONFIG = {
  actionName: 'action_bar_link_handoff',
  iconName: 'icAlertRotatinLight',
  id: 'action_bar_item_handoff',
  to: '/handoff',
  tooltipText: 'Passagem de plantão'
}

const HEALTHCARE_MAP_LINK_CONFIG = {
  actionName: 'action_bar_link_health_care_map',
  iconClass: 'action-bar__healthcare-map',
  id: 'action_bar_item_healthcare_map',
  to: '/healthcare_map',
  tooltipText: 'Mapa do cuidado'
}

const TERTIARY_INTENTION_MAP_LINK_CONFIG = {
  actionName: 'action_bar_link_health_care_map',
  iconName: 'icHospital',
  id: 'action_bar_item_tertiary_intention_map',
  to: '/mapa-de-internacoes-hospitalar',
  tooltipText: 'Mapa de internações'
}

export const SECOND_OPINION_LINK_CONFIG = {
  actionName: 'action_bar_link_second_opinion',
  iconName: 'icHand',
  id: 'action_bar_item__second_opinion',
  to: '/matriciamento',
  tooltipText: 'Opinião de especialista'
}

const CHANNELS_ITEM_CONFIG = {
  component: markRaw(
    defineAsyncComponent(() =>
      import('../ActionBarChannels/ActionBarChannels.vue')
    )
  ),
  id: 'action_bar_item_channels'
}

const EITA_ITEM_CONFIG = {
  component: markRaw(
    defineAsyncComponent(() => import('../ActionBarEita/ActionBarEita.vue'))
  ),
  id: 'action_bar_item_eita'
}

const SECONDARY_ATTENTION_ITEM_CONFIG = {
  component: markRaw(
    defineAsyncComponent(() =>
      import('../ActionBarSecondaryAttention/ActionBarSecondaryAttention.vue')
    )
  ),
  id: 'action_bar_item_secondary'
}

const VIRTUAL_CLINIC_ITEM_CONFIG = {
  component: markRaw(
    defineAsyncComponent(() =>
      import('../ActionBarVirtualClinic/ActionBarVirtualClinic.vue')
    )
  ),
  id: 'action_bar_item_virtual_clinic'
}

export const MENU_LINK_CONFIG = {
  [MENU_TYPE.COCKPIT]: COCKPIT_LINK_CONFIG,
  [MENU_TYPE.WANDA]: WANDA_LINK_CONFIG,
  [MENU_TYPE.CHANNELS]: CHANNELS_ITEM_CONFIG,
  [MENU_TYPE.BUD]: BUD_LINK_CONFIG,
  [MENU_TYPE.HANDOFF]: HANDOFF_LINK_CONFIG,
  [MENU_TYPE.HEALTHCARE_MAP]: HEALTHCARE_MAP_LINK_CONFIG,
  [MENU_TYPE.TERTIARY_INTENTION_MAP]: TERTIARY_INTENTION_MAP_LINK_CONFIG,
  [MENU_TYPE.VIRTUAL_CLINIC]: VIRTUAL_CLINIC_ITEM_CONFIG,
  [MENU_TYPE.EITA]: EITA_ITEM_CONFIG,
  [MENU_TYPE.SECONDARY_ATTENTION]: SECONDARY_ATTENTION_ITEM_CONFIG
}
